import React, { memo } from 'react';
import { HashRouter, Switch, Route, Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import GitHubIcon from '@mui/icons-material/GitHub';
import InventoryIcon from '@mui/icons-material/Inventory';

import Home from '@Components/Common/Home';
import About from '@Components/Common/About';

const StyledLinkButton = styled(Button)(() => ({
  '& a': {
    color: 'inherit',
    textDecoration: 'none',
  },
}));
const StyledLink = styled(Link)(() => ({
  color: 'inherit',
  textDecoration: 'none',
}));

function App(): React.ReactElement {
  return (
    <HashRouter>
      <CssBaseline />
      <React.Fragment>
        <Box p={2}>
          <h1>
            Demo site for <code>react-hook-use-prevent-leave</code>
          </h1>
          <Stack direction="row" spacing={2}>
            <StyledLinkButton variant="outlined" startIcon={<InventoryIcon />}>
              <a
                href="https://www.npmjs.com/package/react-hook-use-prevent-leave"
                target="_blank"
              >
                npm package
              </a>
            </StyledLinkButton>
            <StyledLinkButton variant="outlined" startIcon={<GitHubIcon />}>
              <a
                href="https://github.com/tzynwang/react-hook-use-prevent-leave"
                target="_blank"
              >
                github
              </a>
            </StyledLinkButton>
          </Stack>
        </Box>

        <Divider />

        <Grid container>
          <Grid item xs={12} md={2}>
            <StyledLink to="/">
              <ListItemButton>
                <ListItemText primary="Home" />
              </ListItemButton>
            </StyledLink>
            <StyledLink to="/about">
              <ListItemButton>
                <ListItemText primary="Block demo" />
              </ListItemButton>
            </StyledLink>
          </Grid>
          <Grid item xs={12} md={10} pl={3}>
            <Switch>
              <Route path="/about">
                <About />
              </Route>
              <Route path="/">
                <Home />
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </React.Fragment>
    </HashRouter>
  );
}

export default memo(App);
